<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-details details-area">
        <b-form novalidate >
          <div class="header-form">
            <h5 v-if="formType == 'edit'">Editar {{ oldName }}</h5>
            <h5 v-else>Adicionar {{ equipment }}</h5>
          </div>
          <div class="pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <!-- <b-form-text v-if="!!form.NAME"> Nome * </b-form-text> -->
            <b-form-input
              placeholder="Informe o nome"
              v-model="form.NAME"
              :state="nameState"
              size="sm"
            />
            <b-form-text >Fabricante *</b-form-text>
            <!-- <b-form-text v-if="!!form.MAKER"> Fabricante * </b-form-text> -->
            <b-form-input
              placeholder="Infome o fabricante"
              v-model="form.MAKER"
              :state="makerState"
              size="sm"
            />
            <b-form-text> Saídas * </b-form-text>
            <b-form-input
              type="number"
              v-model="form.OUT"
              :state="outState"
              max="32"
              min="0"
              size="sm"
            />
            <b-form-text> Entradas Digitais * </b-form-text>
            <b-form-input
              type="number"
              v-model="form.IN_DIGITAL"
              :state="digState"
              max="8"
              min="0"
              size="sm"
            />
            <b-form-text> Entradas Analógicas * </b-form-text>
            <b-form-input
              type="number"
              v-model="form.IN_ANALOGIC"
              :state="anState"
              max="8"
              min="0"
              size="sm"
            />
            <b-form-text> Saídas I2C * </b-form-text>
            <b-form-input
              type="number"
              v-model="form.IN_I2C"
              :state="i2cState"
              max="8"
              min="0"
              size="sm"
            />
            <b-form-text> Saídas SDI-12 * </b-form-text>
            <b-form-input
              type="number"
              v-model="form.IN_SDI12"
              :state="sdi12State"
              max="8"
              min="0"
              size="sm"
            />
          </div>
        </b-form>
      </div>
      <footer id="footer">
         <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="mr-1 ml-2"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="mr-2 ml-1"> Salvar </b-btn>
      </footer>
    </div>
    <b-modal
      ref="formError"
      no-close-on-backdrop
      centered
      hide-footer
      body-bg-variant="light"
      title="Atenção!"
    >
      <div class="modal-form row pb-3">
        <div class="col-xs-12 center-xs">
          <alert-icon title="" style="font-size: 3em; color: #ffc107" />
        </div>
        <div class="col-xs-12 error-title">
          Não é possível salvar os dados do formulário porque
        </div>
         <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
      </div>
      <b-btn
        v-if="$refs.formError"
        block
        variant="secondary"
        size="sm"
        @click="$refs.formError.hide"
        >Irei corrigir</b-btn
      >
    </b-modal>
  </div>
</template>

<script>
import {
  testName,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";

export default {
  name: "dir-form",
  props: {
    showForm: Boolean,
    formType: String,
    equipment: String,
    alreadyUsedNames: [Number, Array],
    oldName: [Boolean, Number, String],
    itemToEdit: [Boolean, Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        MAKER: "",
        OUT: 0,
        IN_DIGITAL: 0,
        IN_ANALOGIC: 0,
        IN_I2C: 0,
        IN_SDI12: 0,
      },
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.MAKER = this.itemToEdit.MAKER;
          this.form.OUT = this.itemToEdit.OUT;
          this.form.IN_DIGITAL = this.itemToEdit.IN_DIGITAL;
          this.form.IN_ANALOGIC = this.itemToEdit.IN_ANALOGIC;
          this.form.IN_I2C = this.itemToEdit.IN_I2C;
          this.form.IN_SDI12 = this.itemToEdit.IN_SDI12;
        }
      }
    },
  },
  computed: {
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    nameState() {
      return testName(this.form.NAME);
    },
    makerState() {
      return !!this.form.MAKER.trim() && this.form.MAKER.length < 25;
    },
    outState() {
      return (
        this.form.OUT.length != 0 && this.form.OUT > -1 && this.form.OUT < 33
      );
    },
    digState() {
      return (
        this.form.IN_DIGITAL.length != 0 &&
        this.form.IN_DIGITAL > -1 &&
        this.form.IN_DIGITAL < 9
      );
    },
    anState() {
      return (
        this.form.IN_ANALOGIC.length != 0 &&
        this.form.IN_ANALOGIC > -1 &&
        this.form.IN_ANALOGIC < 9
      );
    },
    i2cState() {
      return (
        this.form.IN_I2C.length != 0 &&
        this.form.IN_I2C > -1 &&
        this.form.IN_I2C < 9
      );
    },
    sdi12State() {
      return (
        this.form.IN_SDI12.length != 0 &&
        this.form.IN_SDI12 > -1 &&
        this.form.IN_SDI12 < 9
      );
    },
  },
  methods: {
    resetForm() {
      this.form = {
        NAME: "",
        MAKER: "",
        OUT: 0,
        IN_DIGITAL: 0,
        IN_ANALOGIC: 0,
        IN_I2C: 0,
        IN_SDI12: 0,
      };
    },
    checkForm() {
      this.errors = [];

      let erros = [
        "Nome do modelo é obrigatório.",
        "Não é possível cadastrar um nome já existente.",
        "Nome do fabricante é obrigatório.",
        "Campo de saídas está inválido.",
        "Campo de entradas digitais está inválido.",
        "Campo de entradas analógicas está inválido.",
        "Campo de entradas I2C está inválido.",
        "Campo de entradas SDI-12 está inválido.",
      ];

      [
        this.nameState,
        this.notRepeatedName,
        this.makerState,
        this.outState,
        this.digState,
        this.anState,
        this.i2cState,
        this.sdi12State,
      ].map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });

      if (this.errors.length) this.$refs.formError.show();
      else {
        if (typeof this.form.OUT == "string")
          this.form.OUT = Number(this.form.OUT);
        if (typeof this.form.IN_DIGITAL == "string")
          this.form.IN_DIGITAL = Number(this.form.IN_DIGITAL);
        if (typeof this.form.IN_ANALOGIC == "string")
          this.form.IN_ANALOGIC = Number(this.form.IN_ANALOGIC);
        if (typeof this.form.IN_I2C == "string")
          this.form.IN_I2C = Number(this.form.IN_I2C);
        if (typeof this.form.IN_SDI12 == "string")
          this.form.IN_SDI12 = Number(this.form.IN_SDI12);
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
.btn {
  margin-bottom: 5px;
}
@media screen and (max-width: 768px) {
  .container-details{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    margin-right: 0;
  }

}
</style>
